// Comprehensive list of 200+ locations in and around Bhubaneswar, Odisha
// Used for programmatic SEO pages

export const bhubaneswarLocations = [
  // Central Bhubaneswar
  { slug: 'unit-1', name: 'Unit 1', area: 'Central', pincode: '751001' },
  { slug: 'unit-2', name: 'Unit 2', area: 'Central', pincode: '751001' },
  { slug: 'unit-3', name: 'Unit 3', area: 'Central', pincode: '751001' },
  { slug: 'unit-4', name: 'Unit 4', area: 'Central', pincode: '751001' },
  { slug: 'unit-6', name: 'Unit 6', area: 'Central', pincode: '751001' },
  { slug: 'unit-8', name: 'Unit 8', area: 'Central', pincode: '751012' },
  { slug: 'unit-9', name: 'Unit 9', area: 'Central', pincode: '751022' },
  { slug: 'ashok-nagar', name: 'Ashok Nagar', area: 'Central', pincode: '751009' },
  { slug: 'master-canteen', name: 'Master Canteen', area: 'Central', pincode: '751001' },
  { slug: 'rajmahal', name: 'Rajmahal', area: 'Central', pincode: '751001' },
  { slug: 'vani-vihar', name: 'Vani Vihar', area: 'Central', pincode: '751004' },
  { slug: 'satya-nagar', name: 'Satya Nagar', area: 'Central', pincode: '751007' },
  { slug: 'bapuji-nagar', name: 'Bapuji Nagar', area: 'Central', pincode: '751009' },
  { slug: 'saheed-nagar', name: 'Saheed Nagar', area: 'Central', pincode: '751007' },
  { slug: 'janpath', name: 'Janpath', area: 'Central', pincode: '751001' },

  // Old Town / Temple Area
  { slug: 'old-town', name: 'Old Town', area: 'Old Town', pincode: '751002' },
  { slug: 'lingaraj-temple', name: 'Lingaraj Temple Area', area: 'Old Town', pincode: '751002' },
  { slug: 'bindusagar', name: 'Bindusagar', area: 'Old Town', pincode: '751002' },
  { slug: 'kedargouri', name: 'Kedargouri', area: 'Old Town', pincode: '751002' },
  { slug: 'ratha-road', name: 'Ratha Road', area: 'Old Town', pincode: '751002' },
  { slug: 'gouri-nagar', name: 'Gouri Nagar', area: 'Old Town', pincode: '751002' },
  { slug: 'kharvel-nagar', name: 'Kharvel Nagar', area: 'Old Town', pincode: '751001' },
  { slug: 'mausima-square', name: 'Mausima Square', area: 'Old Town', pincode: '751002' },
  { slug: 'budheswari', name: 'Budheswari', area: 'Old Town', pincode: '751006' },

  // North Bhubaneswar
  { slug: 'nayapalli', name: 'Nayapalli', area: 'North', pincode: '751012' },
  { slug: 'jaydev-vihar', name: 'Jaydev Vihar', area: 'North', pincode: '751013' },
  { slug: 'chandrasekharpur', name: 'Chandrasekharpur', area: 'North', pincode: '751016' },
  { slug: 'sailashree-vihar', name: 'Sailashree Vihar', area: 'North', pincode: '751021' },
  { slug: 'niladri-vihar', name: 'Niladri Vihar', area: 'North', pincode: '751021' },
  { slug: 'damana', name: 'Damana', area: 'North', pincode: '751030' },
  { slug: 'patia', name: 'Patia', area: 'North', pincode: '751024' },
  { slug: 'kiit-square', name: 'KIIT Square', area: 'North', pincode: '751024' },
  { slug: 'infocity', name: 'Infocity', area: 'North', pincode: '751024' },
  { slug: 'ghatikia', name: 'Ghatikia', area: 'North', pincode: '751003' },
  { slug: 'khandagiri', name: 'Khandagiri', area: 'North', pincode: '751030' },
  { slug: 'udaygiri', name: 'Udaygiri', area: 'North', pincode: '751030' },
  { slug: 'tomando', name: 'Tomando', area: 'North', pincode: '752054' },
  { slug: 'raghunathpur', name: 'Raghunathpur', area: 'North', pincode: '751024' },
  { slug: 'balianta', name: 'Balianta', area: 'North', pincode: '752101' },
  { slug: 'pahala', name: 'Pahala', area: 'North', pincode: '752101' },

  // South Bhubaneswar
  { slug: 'kalpana-square', name: 'Kalpana Square', area: 'South', pincode: '751014' },
  { slug: 'bomikhal', name: 'Bomikhal', area: 'South', pincode: '751010' },
  { slug: 'rasulgarh', name: 'Rasulgarh', area: 'South', pincode: '751010' },
  { slug: 'mancheswar', name: 'Mancheswar', area: 'South', pincode: '751017' },
  { slug: 'palasuni', name: 'Palasuni', area: 'South', pincode: '751020' },
  { slug: 'nandankanan', name: 'Nandankanan', area: 'South', pincode: '754005' },
  { slug: 'baramunda', name: 'Baramunda', area: 'South', pincode: '751003' },
  { slug: 'aiginia', name: 'Aiginia', area: 'South', pincode: '751019' },
  { slug: 'sundarpada', name: 'Sundarpada', area: 'South', pincode: '751002' },
  { slug: 'dumduma', name: 'Dumduma', area: 'South', pincode: '751019' },
  { slug: 'pokhariput', name: 'Pokhariput', area: 'South', pincode: '751020' },
  { slug: 'siripur', name: 'Siripur', area: 'South', pincode: '751019' },
  { slug: 'tamando', name: 'Tamando', area: 'South', pincode: '751031' },

  // East Bhubaneswar
  { slug: 'acharya-vihar', name: 'Acharya Vihar', area: 'East', pincode: '751013' },
  { slug: 'kanan-vihar', name: 'Kanan Vihar', area: 'East', pincode: '751031' },
  { slug: 'chintamaniswar', name: 'Chintamaniswar', area: 'East', pincode: '751006' },
  { slug: 'laxmisagar', name: 'Laxmisagar', area: 'East', pincode: '751006' },
  { slug: 'nalco-square', name: 'Nalco Square', area: 'East', pincode: '751023' },
  { slug: 'chandaka', name: 'Chandaka', area: 'East', pincode: '751024' },
  { slug: 'hanspal', name: 'Hanspal', area: 'East', pincode: '752101' },
  { slug: 'rasulgarh-industrial-estate', name: 'Rasulgarh Industrial Estate', area: 'East', pincode: '751010' },
  { slug: 'brahmeswarpatna', name: 'Brahmeswarpatna', area: 'East', pincode: '751018' },
  { slug: 'jharpada', name: 'Jharpada', area: 'East', pincode: '751006' },

  // West Bhubaneswar
  { slug: 'bjb-nagar', name: 'BJB Nagar', area: 'West', pincode: '751014' },
  { slug: 'forest-park', name: 'Forest Park', area: 'West', pincode: '751009' },
  { slug: 'keshari-nagar', name: 'Keshari Nagar', area: 'West', pincode: '751002' },
  { slug: 'surya-nagar', name: 'Surya Nagar', area: 'West', pincode: '751003' },
  { slug: 'jagamara', name: 'Jagamara', area: 'West', pincode: '751030' },
  { slug: 'kanan-vihar-phase-2', name: 'Kanan Vihar Phase 2', area: 'West', pincode: '751031' },
  { slug: 'bharatpur', name: 'Bharatpur', area: 'West', pincode: '751003' },
  { slug: 'po-irc-village', name: 'IRC Village', area: 'West', pincode: '751015' },
  { slug: 'bda-colony', name: 'BDA Colony', area: 'West', pincode: '751019' },
  { slug: 'gajapati-nagar', name: 'Gajapati Nagar', area: 'West', pincode: '751005' },

  // IT Hub Areas
  { slug: 'infocity-1', name: 'Infocity 1', area: 'IT Hub', pincode: '751024' },
  { slug: 'infocity-2', name: 'Infocity 2', area: 'IT Hub', pincode: '751024' },
  { slug: 'infopark', name: 'Infopark', area: 'IT Hub', pincode: '751024' },
  { slug: 'rail-vihar', name: 'Rail Vihar', area: 'IT Hub', pincode: '751024' },
  { slug: 'fortune-city', name: 'Fortune City', area: 'IT Hub', pincode: '751024' },

  // Residential Colonies
  { slug: 'bhoi-nagar', name: 'Bhoi Nagar', area: 'Residential', pincode: '751022' },
  { slug: 'laxmi-sagar', name: 'Laxmi Sagar', area: 'Residential', pincode: '751006' },
  { slug: 'salia-sahi', name: 'Salia Sahi', area: 'Residential', pincode: '751002' },
  { slug: 'pandav-nagar', name: 'Pandav Nagar', area: 'Residential', pincode: '751001' },
  { slug: 'madhusudan-nagar', name: 'Madhusudan Nagar', area: 'Residential', pincode: '751001' },
  { slug: 'haladipadia', name: 'Haladipadia', area: 'Residential', pincode: '751031' },
  { slug: 'saptasajya-vihar', name: 'Saptasajya Vihar', area: 'Residential', pincode: '751024' },
  { slug: 'cosmopolis', name: 'Cosmopolis', area: 'Residential', pincode: '751019' },
  { slug: 'idco-township', name: 'IDCO Township', area: 'Residential', pincode: '751024' },
  { slug: 'crpf-square', name: 'CRPF Square', area: 'Residential', pincode: '751015' },

  // Popular Markets/Areas
  { slug: 'market-building', name: 'Market Building', area: 'Commercial', pincode: '751001' },
  { slug: 'esplanade-one', name: 'Esplanade One', area: 'Commercial', pincode: '751010' },
  { slug: 'bmc-bhawani-mall', name: 'BMC Bhawani Mall', area: 'Commercial', pincode: '751007' },
  { slug: 'forum-mart', name: 'Forum Mart', area: 'Commercial', pincode: '751016' },
  { slug: 'utkal-kanika-galleria', name: 'Utkal Kanika Galleria', area: 'Commercial', pincode: '751006' },
  { slug: 'big-bazaar-saheed-nagar', name: 'Big Bazaar Saheed Nagar', area: 'Commercial', pincode: '751007' },
  { slug: 'vishal-mega-mart', name: 'Vishal Mega Mart', area: 'Commercial', pincode: '751007' },
  { slug: 'station-square', name: 'Station Square', area: 'Commercial', pincode: '751001' },
  { slug: 'apollo-hospital-area', name: 'Apollo Hospital Area', area: 'Commercial', pincode: '751005' },

  // Educational Hub
  { slug: 'utkal-university', name: 'Utkal University Area', area: 'Educational', pincode: '751004' },
  { slug: 'silicon-institute', name: 'Silicon Institute Area', area: 'Educational', pincode: '751024' },
  { slug: 'kiit-university', name: 'KIIT University Area', area: 'Educational', pincode: '751024' },
  { slug: 'xavier-university', name: 'Xavier University Area', area: 'Educational', pincode: '751013' },
  { slug: 'soa-university', name: 'SOA University Area', area: 'Educational', pincode: '751030' },
  { slug: 'college-square', name: 'College Square', area: 'Educational', pincode: '751009' },
  { slug: 'igit-sarang', name: 'IGIT Sarang', area: 'Educational', pincode: '759146' },

  // Government Offices Area
  { slug: 'secretariat', name: 'Secretariat', area: 'Government', pincode: '751001' },
  { slug: 'ag-square', name: 'AG Square', area: 'Government', pincode: '751001' },
  { slug: 'heads-of-dept', name: 'Heads of Department', area: 'Government', pincode: '751001' },
  { slug: 'ouat', name: 'OUAT', area: 'Government', pincode: '751003' },
  { slug: 'assembly', name: 'Assembly', area: 'Government', pincode: '751001' },
  { slug: 'raj-bhawan', name: 'Raj Bhawan', area: 'Government', pincode: '751007' },

  // Railway Area
  { slug: 'bhubaneswar-railway-station', name: 'Bhubaneswar Railway Station', area: 'Transport', pincode: '751001' },
  { slug: 'lingaraj-temple-road-station', name: 'Lingaraj Temple Road Station', area: 'Transport', pincode: '751002' },
  { slug: 'biju-patnaik-airport', name: 'Biju Patnaik Airport Area', area: 'Transport', pincode: '751020' },
  { slug: 'baramunda-bus-stand', name: 'Baramunda Bus Stand', area: 'Transport', pincode: '751003' },

  // Hospital Areas
  { slug: 'aiims-bhubaneswar', name: 'AIIMS Bhubaneswar', area: 'Healthcare', pincode: '751019' },
  { slug: 'capital-hospital', name: 'Capital Hospital Area', area: 'Healthcare', pincode: '751001' },
  { slug: 'sum-hospital', name: 'SUM Hospital Area', area: 'Healthcare', pincode: '751003' },
  { slug: 'kalinga-hospital', name: 'Kalinga Hospital Area', area: 'Healthcare', pincode: '751024' },
  { slug: 'sparsh-hospital', name: 'Sparsh Hospital Area', area: 'Healthcare', pincode: '751007' },
  { slug: 'care-hospital', name: 'Care Hospital Area', area: 'Healthcare', pincode: '751013' },
  { slug: 'hi-tech-hospital', name: 'Hi-Tech Hospital Area', area: 'Healthcare', pincode: '751024' },

  // Extended Bhubaneswar
  { slug: 'jatni', name: 'Jatni', area: 'Extended', pincode: '752050' },
  { slug: 'khurda', name: 'Khurda', area: 'Extended', pincode: '752055' },
  { slug: 'pipili', name: 'Pipili', area: 'Extended', pincode: '752104' },
  { slug: 'gangapada', name: 'Gangapada', area: 'Extended', pincode: '752062' },
  { slug: 'balipatna', name: 'Balipatna', area: 'Extended', pincode: '752102' },
  { slug: 'begunia', name: 'Begunia', area: 'Extended', pincode: '752062' },
  { slug: 'tangi', name: 'Tangi', area: 'Extended', pincode: '754022' },
  { slug: 'cuttack-road', name: 'Cuttack Road', area: 'Extended', pincode: '751006' },
  { slug: 'puri-road', name: 'Puri Road', area: 'Extended', pincode: '751014' },
  { slug: 'phulbani-chhak', name: 'Phulbani Chhak', area: 'Extended', pincode: '751024' },

  // New Development Areas
  { slug: 'sisupal-garh', name: 'Sisupal Garh', area: 'New Development', pincode: '751002' },
  { slug: 'gothapatna', name: 'Gothapatna', area: 'New Development', pincode: '751003' },
  { slug: 'phulnakhara', name: 'Phulnakhara', area: 'New Development', pincode: '754001' },
  { slug: 'dhauli', name: 'Dhauli', area: 'New Development', pincode: '752104' },
  { slug: 'bhuasuni', name: 'Bhuasuni', area: 'New Development', pincode: '751020' },
  { slug: 'aiginia-square', name: 'Aiginia Square', area: 'New Development', pincode: '751019' },
  { slug: 'nandan-kanan-road', name: 'Nandan Kanan Road', area: 'New Development', pincode: '754005' },

  // Colony Areas
  { slug: 'sahid-nagar-colony', name: 'Sahid Nagar Colony', area: 'Colony', pincode: '751007' },
  { slug: 'ravi-talkies-square', name: 'Ravi Talkies Square', area: 'Colony', pincode: '751001' },
  { slug: 'ganganagar', name: 'Ganganagar', area: 'Colony', pincode: '751013' },
  { slug: 'sriram-nagar', name: 'Sriram Nagar', area: 'Colony', pincode: '751002' },
  { slug: 'mancheswar-industrial-estate', name: 'Mancheswar Industrial Estate', area: 'Colony', pincode: '751017' },
  { slug: 'bhagabanpur', name: 'Bhagabanpur', area: 'Colony', pincode: '751019' },
  { slug: 'kalinga-nagar', name: 'Kalinga Nagar', area: 'Colony', pincode: '751003' },
  { slug: 'niladri-nagar', name: 'Niladri Nagar', area: 'Colony', pincode: '751006' },

  // More Areas
  { slug: 'boudh-nagar', name: 'Boudh Nagar', area: 'Residential', pincode: '751014' },
  { slug: 'barmunda-housing-board', name: 'Barmunda Housing Board', area: 'Residential', pincode: '751003' },
  { slug: 'cda-sector-6', name: 'CDA Sector 6', area: 'Residential', pincode: '751016' },
  { slug: 'cda-sector-7', name: 'CDA Sector 7', area: 'Residential', pincode: '751016' },
  { slug: 'cda-sector-9', name: 'CDA Sector 9', area: 'Residential', pincode: '751016' },
  { slug: 'cda-sector-10', name: 'CDA Sector 10', area: 'Residential', pincode: '751016' },
  { slug: 'cda-sector-11', name: 'CDA Sector 11', area: 'Residential', pincode: '751016' },
  { slug: 'kalinga-vihar', name: 'Kalinga Vihar', area: 'Residential', pincode: '751019' },
  { slug: 'jayadev-nagar', name: 'Jayadev Nagar', area: 'Residential', pincode: '751013' },
  { slug: 'palasuni-square', name: 'Palasuni Square', area: 'Residential', pincode: '751020' },

  // Tech Parks
  { slug: 'bda-tech-park', name: 'BDA Tech Park', area: 'Tech Park', pincode: '751024' },
  { slug: 'stpi-bhubaneswar', name: 'STPI Bhubaneswar', area: 'Tech Park', pincode: '751024' },
  { slug: 'odisha-it-park', name: 'Odisha IT Park', area: 'Tech Park', pincode: '751024' },

  // Suburbs
  { slug: 'mancheswar-railway', name: 'Mancheswar Railway', area: 'Suburb', pincode: '751017' },
  { slug: 'patrapada', name: 'Patrapada', area: 'Suburb', pincode: '751019' },
  { slug: 'baliapara', name: 'Baliapara', area: 'Suburb', pincode: '752101' },
  { slug: 'naraj', name: 'Naraj', area: 'Suburb', pincode: '753011' },
  { slug: 'choudwar', name: 'Choudwar', area: 'Suburb', pincode: '754025' },

  // Additional Areas to reach 200+
  { slug: 'madanpur', name: 'Madanpur', area: 'Extended', pincode: '752050' },
  { slug: 'shyampur', name: 'Shyampur', area: 'Extended', pincode: '751002' },
  { slug: 'kapileswar', name: 'Kapileswar', area: 'Old Town', pincode: '751002' },
  { slug: 'bhingarpur', name: 'Bhingarpur', area: 'Extended', pincode: '752102' },
  { slug: 'uttara', name: 'Uttara', area: 'North', pincode: '751016' },
  { slug: 'bomikhal-colony', name: 'Bomikhal Colony', area: 'Colony', pincode: '751010' },
  { slug: 'brahmeswara', name: 'Brahmeswara', area: 'Old Town', pincode: '751002' },
  { slug: 'mukteswara', name: 'Mukteswara', area: 'Old Town', pincode: '751002' },
  { slug: 'parasurameswara', name: 'Parasurameswara', area: 'Old Town', pincode: '751002' },
  { slug: 'sishupalgarh', name: 'Sishupalgarh', area: 'New Development', pincode: '751002' },
  { slug: 'nuagaon', name: 'Nuagaon', area: 'Extended', pincode: '752050' },
  { slug: 'andharua', name: 'Andharua', area: 'Extended', pincode: '751003' },
  { slug: 'basuaghai', name: 'Basuaghai', area: 'Extended', pincode: '751030' },
  { slug: 'kalinganagar-industrial', name: 'Kalinganagar Industrial', area: 'Industrial', pincode: '755026' },
  { slug: 'infovalley', name: 'Infovalley', area: 'IT Hub', pincode: '751024' },
  { slug: 'nayabazar', name: 'Nayabazar', area: 'Commercial', pincode: '751012' },
  { slug: 'jharpada-square', name: 'Jharpada Square', area: 'Commercial', pincode: '751006' },
  { slug: 'press-chhak', name: 'Press Chhak', area: 'Central', pincode: '751023' },
  { slug: 'delta-square', name: 'Delta Square', area: 'Central', pincode: '751006' },
  { slug: 'fire-station-square', name: 'Fire Station Square', area: 'Central', pincode: '751001' },
  { slug: 'rajbhawan-square', name: 'Rajbhawan Square', area: 'Government', pincode: '751007' },
  { slug: 'museum-square', name: 'Museum Square', area: 'Central', pincode: '751014' },
  { slug: 'ekamra-kanan', name: 'Ekamra Kanan', area: 'Residential', pincode: '751002' },
  { slug: 'ganga-nagar', name: 'Ganga Nagar', area: 'Residential', pincode: '751013' },
  { slug: 'pandra', name: 'Pandra', area: 'Extended', pincode: '751024' },
  { slug: 'samantarapur', name: 'Samantarapur', area: 'Residential', pincode: '751002' },
  { slug: 'bhimpur', name: 'Bhimpur', area: 'Extended', pincode: '751019' },
  { slug: 'bhagabatipur', name: 'Bhagabatipur', area: 'Extended', pincode: '752050' },
  { slug: 'kalarahanga', name: 'Kalarahanga', area: 'Extended', pincode: '751024' },
  { slug: 'bhotapara', name: 'Bhotapara', area: 'Extended', pincode: '751003' },
  { slug: 'bhoi-sahi', name: 'Bhoi Sahi', area: 'Old Town', pincode: '751002' },
  { slug: 'nuasahi', name: 'Nuasahi', area: 'Old Town', pincode: '751002' },
  { slug: 'badagada-brit-colony', name: 'Badagada Brit Colony', area: 'Residential', pincode: '751018' },
  { slug: 'jadupur', name: 'Jadupur', area: 'Residential', pincode: '751024' },
  { slug: 'nakhara', name: 'Nakhara', area: 'Extended', pincode: '751003' },
  { slug: 'paikora', name: 'Paikora', area: 'Extended', pincode: '752002' },
];

// Get location by slug
export const getLocationBySlug = (slug) => {
  return bhubaneswarLocations.find(loc => loc.slug === slug);
};

// Get locations by area
export const getLocationsByArea = (area) => {
  return bhubaneswarLocations.filter(loc => loc.area === area);
};

// Get all unique areas
export const getAllAreas = () => {
  return [...new Set(bhubaneswarLocations.map(loc => loc.area))];
};

// Get popular locations (for homepage)
export const getPopularLocations = () => {
  return bhubaneswarLocations.slice(0, 20);
};

// Generate SEO-friendly content for location
export const generateLocationSEO = (location) => {
  return {
    title: `Order Food Online in ${location.name}, Bhubaneswar | Odisha Zaika`,
    description: `Order delicious Odia food, Biryani, Thali, and more in ${location.name}, ${location.area}, Bhubaneswar. Fast delivery, authentic taste. Order from Odisha Zaika now!`,
    keywords: `food delivery ${location.name}, restaurant ${location.name} Bhubaneswar, odia food ${location.name}, biryani ${location.name}, order food online ${location.name}, ${location.area} food delivery`,
    h1: `Food Delivery in ${location.name}, Bhubaneswar`,
    introText: `Craving delicious Odia cuisine in ${location.name}? Odisha Zaika brings authentic flavors right to your doorstep in ${location.area}, Bhubaneswar. From traditional thalis to mouth-watering biryanis, we serve the best of Odisha's culinary heritage.`
  };
};

export default bhubaneswarLocations;
